var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 0.5C1.40817 0.5 0.666504 1.24167 0.666504 2.16667V10.5C0.666504 10.942 0.842099 11.366 1.15466 11.6785C1.46722 11.9911 1.89114 12.1667 2.33317 12.1667H8.99984V16.3333L11.4998 13.8333L13.9998 16.3333V12.1667H15.6665C16.1085 12.1667 16.5325 11.9911 16.845 11.6785C17.1576 11.366 17.3332 10.942 17.3332 10.5V4.66667V3V2.16667C17.3332 1.72464 17.1576 1.30072 16.845 0.988155C16.5325 0.675595 16.1085 0.5 15.6665 0.5H12.3332H2.33317ZM8.99984 2.16667L11.4998 3.83333L13.9998 2.16667V5.08333L16.4998 6.33333L13.9998 7.58333V10.5L11.4998 8.83333L8.99984 10.5V7.58333L6.49984 6.33333L8.99984 5.08333V2.16667ZM2.33317 2.16667H6.49984V3.83333H2.33317V2.16667ZM2.33317 5.5H4.83317V7.16667H2.33317V5.5ZM2.33317 8.83333H6.49984V10.5H2.33317V8.83333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCertificate);
export default __webpack_public_path__ + "static/media/tax-certificate.c439a5b819290d084ada067c8a989f12.svg";
export { ForwardRef as ReactComponent };